import React from 'react';
import ReactDOM from 'react-dom';
import ButtonModalClose from '../buttonModalClose/ButtonModalClose';

const Modal = ({
  modalRef,
  buttonRef,
  closeModal,
  onKeyDown,
  onClickOutside,
  children,
}) =>
  ReactDOM.createPortal(
    <aside
      tag="aside"
      role="dialog"
      tabIndex="-1"
      aria-modal="true"
      onClick={onClickOutside}
      onKeyDown={onKeyDown}
      className="fixed top-0 left-0 right-0 bottom-0 h-full w-full transform translate-z-0 z-50 backdrop-blur-md bg-black bg-opacity-30"
    >
      <div
        ref={modalRef}
        className="fixed overflow-y-auto top-0 bottom-0 left-0 right-0 bg-white shadow-md lg:top-5 lg:left-5 lg:bottom-5 lg:right-5 lg:max-h-90 lg:max-w-90"
      >
        <ButtonModalClose buttonRef={buttonRef} closeModal={closeModal} />
        <div className="flex items-center justify-center w-full h-full">
          {children}
        </div>
      </div>
    </aside>,
    document.body
  );

export default Modal;
